<template>
    <transition name="slide">
        <div v-if="isShowContent" id="book-tags-container" :class="bookTagPosition">
            <div :class="'tag-box'" v-for="(tag, index) in bookTagContext" :key=tag.name :id="'tag-' + index"
                :style="{ 'background-color': tag.color }" @click="clickTag(tag.type, tag.name)">
                <span class="tag-name">{{ tag.name }}</span>
            </div>
        </div>
    </transition>
</template>

<script>
import { BOOK_TYPE } from '../js/book_define/book_type';
import { store } from '../store';
import { settingStore } from '../js/store/settingStore';
import AppRenderer from '../js/app_renderer';
import { pageTagStore } from '../js/store/pageTagStore';
import { VIEW_TYPE } from '../js/view_type';

export default {
    name: "PageTags",
    data: function () {
        return {
            show: true,
            // 頁籤類型
            TYPE: {
                BOOK: BOOK_TYPE.BOOK,
                STUDY: BOOK_TYPE.STUDY,
                RESOURCE: BOOK_TYPE.RESOURCE,
            },
            // 頁籤資料
            tags: [{
                name: "課本",
                color: "rgb(255, 135, 135)",
                type: "book"
            }, {
                name: "習作",
                color: "rgb(128, 135, 47)",
                type: "study"
            }, {
                name: "周邊資源",
                color: "rgb(101, 152, 255)",
                type: "resource"
            }, {
                name: "影音頻道",
                color: "rgb(229, 146, 22)",
                type: "https://www.youtube.com/channel/UCbzOFvbPbnfAfp4lQwL3DbA/featured"
            }],
            // 當前課本頁數
            currentBookPage: 0,
            // 當前習作頁數
            currentStudyPage: 0,
            pageTagStore,
            store
        };
    },
    methods: {
        toggle() {
            this.show = !this.show;
        },
        setTags(tags) {
            this.tags = tags;
        },
        clickTag(type, name) {
            console.log(`type: ${type}`)
            switch (type) {
                case this.TYPE.BOOK:
                    if (store.nowBook == BOOK_TYPE.BOOK) {
                        return;
                    } else {
                        if (store.nowBook == BOOK_TYPE.STUDY) {
                            // this.currentStudyPage = store.nowPage;
                            store.currentStudyPage = store.nowPage;
                        }
                        window.pageControl.gotoPage(store.currentBookPage, BOOK_TYPE.BOOK);
                    }
                    break;
                case this.TYPE.STUDY:
                    if (store.nowBook == BOOK_TYPE.STUDY) {
                        return;
                    } else {
                        if (store.nowBook == BOOK_TYPE.BOOK) {
                            // this.currentBookPage = store.nowPage;
                            store.currentBookPage = store.nowPage;
                        }
                        window.pageControl.gotoPage(store.currentStudyPage, BOOK_TYPE.STUDY);
                    }
                    break;
                case this.TYPE.RESOURCE:
                    window.pageControl.gotoPage(0, BOOK_TYPE.RESOURCE);
                    break;
                default:
                    AppRenderer.Instance.openWebSite(type);
                    break;
            }
        }
    },
    computed: {
        bookTagPosition() {
            return { "left": settingStore.toolbarPosition == 2 }
        },
        bookTagContext() {
            if (store.nowView == VIEW_TYPE.WEB || store.nowView == VIEW_TYPE.ANDROID || store.nowView == VIEW_TYPE.IOS) {
                // 網頁版、app版需不顯示周邊資源
                return pageTagStore.tags.filter((tag) => tag.type != "resource");
            } else {
                return pageTagStore.tags
            }
        },
        isShowContent() {
            console.log(`store.onlyRead: ${store.onlyRead}`);
            if(store.onlyRead) {
                return false;
            }else {
                return this.show;
            }
        }
    }
};
</script>

<style src="../assets/css/PageTags.css" scoped ></style>
